import React, { useEffect, useRef, useState } from "react";
import { getBidderByUuid, updateBidderForEvent } from "services";
import { JBSecondaryBidderTable } from "./JbSecondaryBidderTable";
import { Button } from "../../../../../../shadcn/components/ui/button";
import {
  fetchPrimaryBidderESignDocument,
  notifyPrimaryBidderAboutAllConsentsReceived,
} from "services/bidder";
interface JBCompletedStepsComponentProps {
  bidderUuid: any;
  bidder: any;
  stepsTitles: any;
  activeStep: any;
  setActiveStep: any;
  init: any;
}
export default function JBSecondaryCompletedComponent({
  bidderUuid,
  bidder,
  stepsTitles,
  activeStep,
  setActiveStep,
  init,
}: JBCompletedStepsComponentProps) {
  const [loading, setLoading] = useState(false);
  const [secondaryBidderConsentDetails, setSecondaryBidderConsentDetails] =
    useState([]);

  const divRef = useRef<HTMLDivElement | null>(null);
  const [width, setWidth] = useState<number>(0);
  const pollingCall = async (primaryBidderUuid: string) => {
    if (!primaryBidderUuid) return;
    try {
      const currentPrimaryBidderData: any = await getBidderByUuid(
        primaryBidderUuid
      );
      if (!currentPrimaryBidderData) return;
      const secondaryBidders = currentPrimaryBidderData?.bidder_relations || [];
      const consentDataList =
        currentPrimaryBidderData?.esigned_data?.consent_data || [];
      const consentMap =
        consentDataList.length > 0
          ? Object.fromEntries(
              consentDataList.map((c: any) => [c.bidder_uuid, c.consent_status])
            )
          : {};

      const updatedBidders = secondaryBidders.map((b: any) => {
        return {
          ...b,
          consent_status: consentMap[b.bidder_uuid] || "pending",
        };
      });
      setSecondaryBidderConsentDetails(updatedBidders);
      if (
        currentPrimaryBidderData.verification_step === "wait_for_consent" ||
        currentPrimaryBidderData.verification_step === "completed"
      ) {
        const consentDataList =
          currentPrimaryBidderData?.esigned_data?.consent_data || [];
        const totalNonApproved = consentDataList.filter(
          (c: any) => c.consent_status !== "approved"
        ).length;
        if (totalNonApproved === 0) {
          console.log("called: ", "called");
          if (!currentPrimaryBidderData?.esigned_data?.all_consent_received) {
            await notifyPrimaryBidderAboutAllConsentsReceived({
              eligible_bidders_uuid: primaryBidderUuid,
            });
          }
          if (!currentPrimaryBidderData?.esigned_data?.is_kyc_file_persisted) {
            const payload = {
              eligible_bidder_uuid: primaryBidderUuid,
              e_sign_request_id:
                currentPrimaryBidderData?.esigned_data?.request_id,
            };
            await fetchPrimaryBidderESignDocument(payload);
          }
          const primaryBidderData: any = await getBidderByUuid(
            primaryBidderUuid
          );
          await updateBidderForEvent({
            uuid: primaryBidderUuid,
            esigned_data: {
              ...primaryBidderData?.esigned_data,
              all_consent_received: true,
              document_saved: true,
            },
            verification_step: "completed",
          });
          const bidderData: any = await getBidderByUuid(bidderUuid);
          console.log("verification_step", bidderData?.verification_step);
          if (bidderData?.verification_step === "wait_for_consent") {
            console.log("here-calling");
            await updateBidderForEvent({
              uuid: bidderUuid,
              verification_step: "completed",
              digio_request_status: "approved",
            });
            setActiveStep(activeStep + 1);
            await new Promise((resolve) => setTimeout(resolve, 1000));
            await init();
            return;
          }
        }
      }
    } catch (err) {
      console.error("Error during pollingCall:", err);
    }
  };
  useEffect(() => {
    if (!bidderUuid) return;
    if (bidder?.verification_step !== "wait_for_consent") return;

    let intervalId: NodeJS.Timeout | null = null;
    let isFetching = false;

    const startPolling = async () => {
      if (isFetching) return; // skip if already running
      isFetching = true;
      try {
        await pollingCall(bidder?.meta?.primary_bidder_uuid);
      } catch (error) {
        console.error("Polling error:", error);
      } finally {
        isFetching = false;
      }
    };

    // Run immediately once
    startPolling();

    // Then run every 30 seconds
    intervalId = setInterval(startPolling, 30000);
    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, [bidder]);

  useEffect(() => {
    const updateWidth = () => {
      if (divRef.current) {
        setWidth(divRef.current.offsetWidth);
      }
    };

    updateWidth();
    window.addEventListener("resize", updateWidth);

    return () => window.removeEventListener("resize", updateWidth);
  }, [window.innerWidth, width, bidder?.verification_step]);
  console.log("bidder?.verification_step", bidder?.verification_step);
  return (
    <div>
      {loading ? (
        <div className="flex flex-col flex-grow h-full mt-4">
          <div className="flex justify-center items-center">
            <div className="w-12 h-12 border-8 border-t-6 border-brand-orange rounded-full animate-spin bg-gradient-to-r from-brand-orange to-blue-100 shadow-lg"></div>
          </div>
        </div>
      ) : (
        <div ref={divRef}>
          {bidder?.verification_step === "wait_for_consent" ? (
            <div className="py-4 bg-white border-gray-100">
              <h2 className="text-sm md:text-lg font-semibold text-gray-800 mb-1">
                Waiting for Other Bidders to Provide Consent
              </h2>

              <p className="text-sm text-gray-600 mb-4">
                You’ve successfully completed your part. Once all bidders
                provide their consent, the application will proceed
                automatically.
              </p>

              <div className="space-y-4">
                <h3 className="text-center text-xs md:text-base font-semibold text-gray-800 flex gap-2 items-center">
                  Secondary Bidder Consent Status
                </h3>

                <div className="mx-auto" style={{ width: `${width - 10}px` }}>
                  <JBSecondaryBidderTable
                    bidders={secondaryBidderConsentDetails}
                  />
                </div>
              </div>
            </div>
          ) : (
            <div className="p-4 bg-green-50 border border-green-200">
              <h2 className="text-lg md:text-xl font-semibold text-green-800 mb-2">
                KYC Completed
              </h2>
              <p className="text-sm text-gray-700 mb-2">
                Your KYC process has been successfully completed and the consent
                has been signed.
              </p>
              <p className="text-sm text-gray-700 mb-3">
                Your part of the verification is now complete. You may safely
                close this tab.
              </p>
              <p className="text-sm text-gray-700 mb-4">
                The signed documents have been sent to the banker for
                verification. Once the banker approves, your participation
                status will be updated automatically.
              </p>
              <p className="text-sm text-gray-700 mb-5">
                You can check your auction participation status anytime under
                the
                <span className="font-medium text-gray-900">
                  {" "}
                  My Events{" "}
                </span>{" "}
                tab.
              </p>
              <a href="/auction-events">
                <Button> Go to Auctions events</Button>
              </a>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
